export default __webpack_public_path__ + "static/media/telephone.259eb581.svg";